import React from "react";

import { CreationFooter } from "components/organisms/CreationModal";

/** Cancel / Back + primary action footer for the source forms. */
const SourceFormFooter = ({
    language,
    onBack,
    onCancel,
    onSubmit,
    submitLabel,
    submitIcon,
    isCancelDisabled = false,
    isSubmitDisabled = false,
    isSubmitLoading = false,
}) => (
    <CreationFooter
        onBack={onBack}
        backLabel={language?.buttons?.back ?? "Back"}
        onCancel={onCancel}
        cancelLabel={language?.buttons?.cancel ?? "Cancel"}
        isCancelDisabled={isCancelDisabled}
        onSubmit={onSubmit}
        submitLabel={
            submitLabel ?? language?.buttons?.create_source ?? "Create source"
        }
        submitIcon={submitIcon}
        isSubmitDisabled={isSubmitDisabled}
        isSubmitLoading={isSubmitLoading}
        submitTestId="create-source-submit"
    />
);

export default SourceFormFooter;
